import * as tslib_1 from "tslib";
import * as React from 'react';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
var styles = require('./OptionsCheckbox.scss');
var classNames = require('classnames/bind').bind(styles);
export default function OptionsCheckbox(props) {
    return (React.createElement(Checkbox, tslib_1.__assign({}, props, { styles: {
            root: classNames(styles.root, (props.styles || {}).root),
        } })));
}
//# sourceMappingURL=OptionsCheckbox.js.map